import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Nashville needed",
      "Ideal for Fort Campbell soldiers with PCS orders",
      "Perfect for 101st Airborne deployment leave timelines",
      "Great for Austin Peay students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Clarksville post offices",
      "Good for planned international leave or TDY travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Montgomery County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Nashville (~50 mi) — no Clarksville walk-in",
      "NPIC appointment required before traveling to Nashville",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ClarksvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Clarksville"
      introText="Clarksville travelers — Fort Campbell soldiers with PCS orders, 101st Airborne families preparing for overseas assignments, Austin Peay students heading abroad for a semester, and Montgomery County residents planning international trips — have several options for getting a passport fast. Here is how they compare, and why most military families and Clarksville residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Nashville."
      options={options}
      emergencyDescription="Clarksville does not have its own regional passport agency. The closest is the Atlanta Passport Agency at 805 Broadway — about 50 miles away via I-24. For Fort Campbell soldiers on tight PCS timelines, that 50-mile drive plus Nashville traffic, the uncertain availability of same-day appointments, and the possibility of being turned away with incomplete documentation makes the DIY agency route a significant gamble. Military families with deployment orders cannot afford to lose a full duty day only to discover their application needs additional documentation."
      disclaimerText="*Processing speed depends on eligibility and documentation. Clarksville does not have a regional passport agency — the closest is Nashville, approximately 50 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}